/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Swiper from 'swiper';
import Component from 'can/component/component';
import template from './statistics.stache';
import DomEventsManager from 'scripts/dom-events-manager';
import can from 'can';
import appContext from 'scripts/app-context';
import dtm from 'scripts/services/dtm';

const statisticsPagePath = window.globalSettings.pagePaths.playerStatistics;

Component.extend({
    tag: 'leader-board-statistics',
    template: template,
    leakScope: false,
    viewModel: {
        statisticsPagePath: statisticsPagePath,
        define: {
            showFullStats: {
                type: 'boolean',
                value: false,
            },
        },
        describe: {
            round: {
                type: 'number',
                value: 1,
            },
            playerInfo: {
                Type: can.Map,
                value: null,
            },
            pageType: {
                type: 'string',
            },
        },
    },
    events: {
        inserted: function() {
            DomEventsManager.subscribe(this);
            appContext.model.bind(
                'drawer-content-tabs-toggle',
                this.resizeSwiper.bind(this),
            );
        },
        destroy: function() {
            DomEventsManager.unsubscribe(this);
            appContext.model.unbind(
                'drawer-content-tabs-toggle',
                this.resizeSwiper.bind(this),
            );
        },
        onLayout: function(layout) {
            this.initSwiper(layout);
        },
        initSwiper: function(screenSize) {
            let $swiperContainer = this.element.find('.swiper-container'),
                slideNumber = this.element.find('.swiper-slide').length;
            this.size = screenSize ? screenSize : this.size;

            if (this.swiper) {
                this.swiper.destroy();
                $swiperContainer.find('.swiper-wrapper').removeAttr('style');
                $swiperContainer.find('.swiper-slide').removeAttr('style');
            }
            let slidesPerViewCount;

            if (
                this.element.closest('.c-shots-and-stats').length &&
                (this.size === 'large' || this.size === 'extra-large')
            ) {
                slidesPerViewCount = 4;
            } else {
                slidesPerViewCount =
                    this.size === 'small' || this.size === 'extra-small'
                        ? 1
                        : 2;
            }
            if (slideNumber > 1) {
                this.swiper = new Swiper($swiperContainer, {
                    loop: false,
                    simulateTouch: true,
                    speed: 1000,
                    slidesPerGroup: slidesPerViewCount,
                    slidesPerView: slidesPerViewCount,
                    pagination: {
                        el: $swiperContainer.find('.swiper-pagination'),
                        clickable: true,
                    },
                    navigation: {
                        prevEl: $swiperContainer.find('.swiper-button--prev'),
                        nextEl: $swiperContainer.find('.swiper-button--next'),
                    },
                });

                this.swiper.on('slideChange', () => {
                    dtm.trackDrawerStatisticsScroll(this.viewModel.pageType);
                });
            }
        },
        resizeSwiper: function(drawerTabChange, activeTab) {
            if (activeTab == 'stats') {
                this.initSwiper();
            }
        },
    },
});
